import idx from 'idx'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { compose, lifecycle, withHandlers, withStateHandlers } from 'recompose'

import * as inviteModule from 'modules/invite'
import * as userActions from 'actions/userActions'

export default compose(
  connect(
    (state) => {
      return {
        hasError: idx(state, _ => _.progress.checkToken.hasError) || false,
        errorMessage: idx(state, _ => _.progress.checkToken.error.message) || null,
        hasSignupError: idx(state, _ => _.progress.createAccount.hasError) || false,
      }
    }, 
    (dispatch) => {
      const actions = {
        ...userActions,
        ...inviteModule,
      }
      return {
        actions: bindActionCreators(actions, dispatch),
      }
    }, 
  ),
  withStateHandlers(
    () => ({
      email: null,
      state: 'verify'
    }),
    {
      setState: oldState => state => ({
        ...oldState,
        ...state
      })
    }
  ),
  // Handlers
  withHandlers({
    checkToken: ({ actions }) => (inviteUUID, token, callback) => {
      actions.checkTokenVerification(inviteUUID, token, callback)
    },
    acceptTrapInvitation: ({ actions }) => (inviteUUID, token) => {
      actions.acceptTrapInvitation(inviteUUID, token)
    }
  }),
  withHandlers({
    beginCheckToken: ({
      setState, checkToken, location, match, acceptTrapInvitation 
    }) => () => {
      const inviteUUID = match.params ? match.params.uuid : null
      const token = location.search.replace('?token=', '')

      checkToken(inviteUUID, token, (data) => {
        // If token is valid, accept the invitation
        if (data.email && data.profileExist) {
          acceptTrapInvitation(inviteUUID, token)
        } else if (data.email && !data.profileExist) {
          setState({ state: 'signup', email: data.email })
        }
      })
    }
  }),
  withHandlers({
    onSignupSubmit: ({ actions, beginCheckToken, setState }) => (values) => {
      actions.createUser(values, () => {
        setState({ state: 'verify' })
        beginCheckToken()
      })
    },
  }),
  lifecycle({
    componentDidMount() {
      const {
        beginCheckToken
      } = this.props
      
      beginCheckToken()
    }
  }),
)



// WEBPACK FOOTER //
// ./src/containers/invitations/TrapInviteVerify/TrapInviteVerify.enhancer.js